export const AssetsCategoryEnum = {
  lookupTypeId: 1230,
};
